export default "__VITE_ASSET__BzCzkSTl__"